import React from "react";
import { useAgency } from "@/context/AgencyContext";
import { Building2, Check, ChevronsUpDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function AgencySwitcher() {
  const { agencies, active, switchAgency } = useAgency();

  if (!agencies || agencies.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="agency-switcher-trigger"
        className="flex items-center gap-2 px-3 h-9 rounded-sm border border-border bg-white hover:bg-slate-50 transition-colors min-w-[180px]"
      >
        <Building2 className="w-4 h-4 text-amber-600 shrink-0" />
        <div className="flex-1 min-w-0 text-left">
          <div className="text-[9px] uppercase tracking-widest text-muted-foreground font-mono-data leading-none">
            Active agency
          </div>
          <div className="text-xs font-semibold text-slate-900 truncate mt-0.5">
            {active?.name || "Select agency"}
          </div>
        </div>
        <ChevronsUpDown className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64 rounded-sm">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-muted-foreground font-mono-data">
          Switch agency context
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {agencies.map((a) => (
          <DropdownMenuItem
            key={a.id}
            onClick={() => switchAgency(a.id)}
            className="rounded-sm cursor-pointer"
            data-testid={`agency-option-${a.id}`}
          >
            <div className="flex items-center gap-2 w-full min-w-0">
              <Check
                className={`w-3.5 h-3.5 shrink-0 ${
                  active?.id === a.id ? "text-amber-600" : "text-transparent"
                }`}
              />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-slate-900 truncate">
                  {a.name}
                </div>
                <div className="text-[10px] text-muted-foreground font-mono-data">
                  {a.line_count} {a.line_count === 1 ? "line" : "lines"}
                  {a.is_default ? " · default" : ""}
                  {a.active === false ? " · inactive" : ""}
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
